export const USE_PLAYBACK_CONTROL = "UsePlaybackControl";
export const CLASS_PLAYER_REBUFFERING = "Class - Player Rebuffering";
